export const Logout = () => (
  <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 -960 960 960">
    <path d="M206.31-108q-41.03 0-69.67-28.64T108-206.31v-547.38q0-41.03 28.64-69.67T206.31-852h274.07v86H206.31q-4.62 0-8.46 3.85-3.85 3.84-3.85 8.46v547.38q0 4.62 3.85 8.46 3.84 3.85 8.46 3.85h274.07v86H206.31Zm434.92-161.23-62.54-63.39L684.08-438H357.85v-86h326.23L578.69-629.38l62.54-61.39L852-480 641.23-269.23Z" />
  </svg>
);
